import '.b2{position:relative;}.ssr-plugin'
import '.iv{width:64px;}.ssr-plugin'
import '.iw{height:64px;}.ssr-plugin'
import '.ao{flex-shrink:0;}.ssr-plugin'
import '.bh{position:absolute;}.ssr-plugin'
import '.ix{bottom:-4px;}.ssr-plugin'
import '.i7{right:-4px;}.ssr-plugin'
import '.fu{border-radius:50%;}.ssr-plugin'
import '.iy{border:2px solid var(--palette-white);}.ssr-plugin'
import '.al{overflow:hidden;}.ssr-plugin'
import '.iz{width:32px;}.ssr-plugin'
import '.j0{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="b2 iv iw ao"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bh ix i7 fu iy al iz j0"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
